import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core-module/guards/authGuard';
import { AppSelectivePreloadingStrategy } from './core-module/services/app-selective-preloading.strategy';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./shared-module/components/home-component/home.module').then(
        (m) => m.HomeModule
      ),
  },
  {
    path: 'about',
    data: { preload: true },
    loadChildren: () => import('./about/about.module').then((m) => m.AboutModule),
  },
  {
    path: 'deviceList',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./shared-module/components/landing-page/device-list.module').then(
        (m) => m.DeviceListModule
      ),
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  // { path: 'login', loadChildren: () => import(`./shared-module/components/login-component/login.module`).then(m => m.LoginModule) },
  {
    path: 'login',
    loadChildren: () =>
      import('./shared-module/components/home-component/home.module').then(
        (m) => m.HomeModule
      ),
  },
  {
    path: 'featureSupported',
    loadChildren: () =>
      import('./shared-module/components/feature-supported/feature-supported-page.module').then(
        (m) => m.FeatureSupportedPageModule
      ),
  },
  {
    path: 'featureNonSupported',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./shared-module/components/feature-non-supported/feature-non-supported.module').then(
        (m) => m.FeatureNonSupportedModule
      ),
  },
  {
    path: 'featureLanding',
    data: { preload: true },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./shared-module/components/set-feature-landing/set-feature-landing.module').then(
        (m) => m.SetFeatureLandingModule
      ),
  },
  { path: '**', redirectTo: '/home' } // Wildcard route - must be last
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      preloadingStrategy: AppSelectivePreloadingStrategy,
    }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}

